import {
  LIST_ACCOUNTS,
} from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/billing-accounts',
    component: () => import(/* webpackChunkName: "accounts" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_ACCOUNTS,
    },
  },
];
